import React from 'react';
import { useTranslation } from 'react-i18next';
import { BottomInfo, Dot, InfoItem } from './styled';
import useScreenSize from '../../../../hooks/useScreenSize';
import { capitalizeFirstLetter } from '../../../../utils/helpers/common';
import { useClient } from '../../../../hooks/useClient';

interface BottomInfoSectionProps {
  isAuthor: boolean;
  isExpired: boolean;
  id: string;
  views: number;
  updatedAt: string;
  expiresAt: string;
  isExpiredManually: boolean;
}

export const BottomInfoSection: React.FC<BottomInfoSectionProps> = ({
  isAuthor,
  isExpired,
  id,
  views,
  updatedAt,
  expiresAt,
  isExpiredManually
}) => {
  const { t } = useTranslation();
  const { isSmallDesktop, isLarge } = useScreenSize();
  const isCapitalize = updatedAt.split(' ').length === 2;
  const isClient = useClient();

  const getCurrentTimestamp = () => {
    if (isCapitalize) {
      const [date, time] = updatedAt.split(' ');
      return `${date}, ${time}`.replace(',,', ',');
    }
    return updatedAt;
  };

  const infoList = [
    {
      name: '№',
      value: id,
      cypress: 'item-id'
    },
    {
      name: t('pages.current_item.bottom_info.views'),
      value: views,
      cypress: 'item-views'
    },
    {
      isNotToShow: isExpired,
      name: t('pages.current_item.bottom_info.updatedAt'),
      value: capitalizeFirstLetter(getCurrentTimestamp()),
      cypress: 'item-updated-at'
    },
    {
      isNotToShow:
        !isExpired ||
        isExpiredManually ||
        !expiresAt ||
        (isAuthor && isExpired),
      name: isExpired
        ? t('pages.current_item.bottom_info.expiredAt')
        : t('pages.current_item.bottom_info.expiresAt'),
      value: expiresAt,
      cypress: 'item-expires-at'
    }
  ];

  const filteredInfo = infoList.filter(item => !item.isNotToShow);
  const withMargin = !isAuthor && !(isSmallDesktop || isLarge) && isClient;

  return (
    <BottomInfo data-cy="bottom-info" $withMargin={withMargin}>
      {filteredInfo.map((item, index) => (
        <InfoItem tag="body_1" key={index} data-cy={item.cypress}>
          {item.name}
          {item.cypress === 'item-id' ? '' : ':'} {item.value}
          {index < filteredInfo.length - 1 && <Dot>•</Dot>}
        </InfoItem>
      ))}
    </BottomInfo>
  );
};
